<div [ngClass]="(globals.isDesktop)?'desktop':'mobile'">
    <div class="comments">
        <app-new-comment (success)="commentAdded($event)" [projectId]="projectId"></app-new-comment>
        <ng-container *ngFor="let comment of comments?.slice()">
            <div *ngIf="!globals.isDesktop" class="border"></div>
            <app-comment-item [comment]="comment"></app-comment-item>
        </ng-container>
    </div>
</div>
